(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["guttos-editorial"] && !Shopify.designMode) return;
  try {
    
(() => {
  function galleries(root) {
    root.querySelectorAll('[data-ge-gallery]').forEach(gallery => {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      const track = gallery.querySelector('.ge-gallery-track');
      const dots = [...gallery.querySelectorAll('.ge-gallery-dots i')];
      let pending = false;
      let gesture = null;
      let suppressUntil = 0;
      track.addEventListener('scroll', () => {
        if (pending) return;
        pending = true;
        requestAnimationFrame(() => {
          const index = Math.round(track.scrollLeft / track.clientWidth);
          dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
          pending = false;
        });
      }, {passive:true});
      track.addEventListener('pointerdown', event => { gesture = {x:event.clientX,y:event.clientY}; }, {passive:true});
      track.addEventListener('pointerup', event => {
        if (gesture && Math.abs(event.clientX - gesture.x) > 12 && Math.abs(event.clientX - gesture.x) > Math.abs(event.clientY - gesture.y)) suppressUntil = performance.now() + 400;
        gesture = null;
      }, {passive:true});
      track.addEventListener('pointercancel', () => { gesture = null; }, {passive:true});
      track.addEventListener('click', event => { if (performance.now() < suppressUntil) { event.preventDefault(); event.stopPropagation(); } }, true);
      track.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        track.scrollBy({left:(event.key === 'ArrowRight' ? 1 : -1) * track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      });
    });
  }
  function init(root) {
    root.querySelectorAll('[data-ge-home]').forEach(home => {
      if (home.dataset.ready) return;
      home.dataset.ready = 'true';
      const offer = home.querySelector('[data-offer-preview]');
      if (offer) {
        offer.addEventListener('submit', async event => {
          const form = event.target.closest('[data-offer-form]');
          if (!form) return;
          event.preventDefault();
          const button = form.querySelector('[data-offer-add]');
          if (button.disabled) return;
          button.disabled = true;
          const status = offer.querySelector('[data-offer-selection]');
          status.textContent = '';
          try {
            const response = await fetch(form.action + '.js', {method:'POST',body:new FormData(form),headers:{Accept:'application/json'}});
            const result = await response.json();
            if (!response.ok) throw new Error(result.description || result.message);
            status.textContent = offer.querySelector('[data-offer-two]').textContent;
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          } catch (error) {
            status.textContent = error.message || offer.querySelector('[data-offer-one]').textContent;
          } finally {button.disabled = false;}
        });
      }
      home.addEventListener('click', event => {
        const link = event.target.closest('[data-ge-color]');
        if (!link || link.getAttribute('aria-disabled') === 'true' || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const card = link.closest('[data-ge-color-card]');
        const template = [...card.querySelectorAll('[data-ge-color-content]')].find(item => item.dataset.geColorContent === link.dataset.geColor);
        if (!template) return;
        event.preventDefault();
        const content = card.querySelector('[data-ge-card-content]');
        content.replaceChildren(template.content.cloneNode(true));
        card.querySelectorAll('[data-ge-color]').forEach(item => {item.classList.toggle('is-active',item === link);item.setAttribute('aria-current',item === link ? 'true' : 'false');});
        galleries(content);
      });
      const heroVideo = home.querySelector('.ge-hero-video');
      const videoToggle = home.querySelector('[data-ge-video-toggle]');
      const campaignSides = [...home.querySelectorAll('.ge-hero-still')];
      const campaignSlides = campaignSides.map(side => [...side.querySelectorAll('[data-ge-campaign]')]);
      const desktopCampaign = matchMedia('(min-width: 750px)');
      const reducedCampaign = matchMedia('(prefers-reduced-motion: reduce)');
      if (campaignSlides.length === 2 && campaignSlides[0].length > 1) {
        let campaignIndex = 0;
        let campaignBusy = false;
        const showCampaign = async index => {
          if (campaignBusy) return;
          campaignBusy = true;
          const next = campaignSlides.map(slides => slides[index]);
          try {
            await Promise.all(next.map(slide => {const img=slide.querySelector('img');img.loading='eager';return img.decode();}));
            if (!home.isConnected) return;
            campaignSlides.forEach(slides => slides.forEach((slide,i) => {
              slide.classList.toggle('is-active',i===index);
              slide.tabIndex = i===index ? 0 : -1;
              slide.setAttribute('aria-hidden',String(i!==index));
            }));
            campaignIndex = index;
          } catch {} finally {campaignBusy = false;}
        };
        if (desktopCampaign.matches && !reducedCampaign.matches) {
          let start = Math.floor(Math.random()*campaignSlides[0].length);
          try {const previous=Number(sessionStorage.getItem('guttos-campaign-start'));if(start===previous)start=(start+1)%campaignSlides[0].length;sessionStorage.setItem('guttos-campaign-start',String(start));} catch {}
          showCampaign(start);
        }
        const campaignTimer = setInterval(() => {
          if (!home.isConnected) {clearInterval(campaignTimer);return;}
          if (!desktopCampaign.matches || reducedCampaign.matches || document.hidden || heroVideo?.paused || home.querySelector('.ge-hero').getBoundingClientRect().bottom<=0 || campaignSides.some(side=>side.matches(':hover,:focus-within'))) return;
          showCampaign((campaignIndex+1)%campaignSlides[0].length);
        },3000);
      }

      if (heroVideo && videoToggle) {
        const updateVideo = () => {videoToggle.setAttribute('aria-label',heroVideo.paused ? videoToggle.dataset.playLabel : videoToggle.dataset.pauseLabel);videoToggle.querySelector('span').textContent=heroVideo.paused ? '▷' : 'Ⅱ';};
        heroVideo.addEventListener('play',updateVideo);
        heroVideo.addEventListener('pause',updateVideo);
        videoToggle.addEventListener('click',()=>{if(heroVideo.paused)heroVideo.play().catch(updateVideo);else heroVideo.pause();});
        heroVideo.muted = true;
        heroVideo.playsInline = true;
        if(matchMedia('(prefers-reduced-motion: reduce)').matches)heroVideo.pause();
        else heroVideo.play().catch(updateVideo);
        updateVideo();
      }
      const list = home.querySelector('[data-ge-tabs]');
      const tabs = [...home.querySelectorAll('[data-ge-tab]')];
      const host = home.querySelector('[data-ge-panels]');
      list.setAttribute('role','tablist');
      list.setAttribute('aria-orientation','horizontal');
      const activate = tab => {
        const key = tab.dataset.geTab;
        let panel = home.querySelector('[data-ge-panel="' + key + '"]');
        if (!panel) {
          const template = home.querySelector('[data-ge-template="' + key + '"]');
          host.append(template.content.cloneNode(true));
          panel = home.querySelector('[data-ge-panel="' + key + '"]');
          galleries(panel);
          document.dispatchEvent(new CustomEvent('guttos:filters:init'));
        }
        home.querySelectorAll('[data-ge-panel]').forEach(item => {item.hidden = item !== panel;item.setAttribute('role','tabpanel');});
        tabs.forEach(item => {item.setAttribute('aria-selected',String(item === tab));item.tabIndex = item === tab ? 0 : -1;item.classList.toggle('is-active',item === tab);});
      };
      tabs.forEach((tab,index) => {
        tab.setAttribute('role','tab');
        tab.setAttribute('aria-controls','ge-panel-' + home.id.replace('ge-','') + '-' + tab.dataset.geTab);
        tab.addEventListener('click', event => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();activate(tab);
        });
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowLeft') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowRight') next = (index + tabs.length - 1) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (event.key === ' ') {event.preventDefault();activate(tab);return;}
          if (next !== undefined) {event.preventDefault();tabs[next].focus();activate(tabs[next]);}
        });
      });
      const instagram = home.querySelector('.ge-instagram');
      if (instagram) {
        const feed = instagram.querySelector('#insta-feed');
        const enableFeedSwipe = () => {
          const track = feed.querySelector('.instafeed-new-layout-wrapper');
          if (!track || track.dataset.geSwipeReady) return;
          track.dataset.geSwipeReady = 'true';
          track.tabIndex = 0;
          track.setAttribute('aria-label','פוסטים באינסטגרם — החליקו לצפייה בעוד פוסטים');
          instagram.querySelectorAll('[data-instafeed-prevent-touch-scroll]').forEach(element => element.setAttribute('data-instafeed-prevent-touch-scroll','false'));
          track.addEventListener('keydown',event => {
            if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
            event.preventDefault();
            track.scrollBy({left:(event.key === 'ArrowRight' ? 1 : -1) * track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
          });
        };
        if (feed) {
          new MutationObserver(enableFeedSwipe).observe(feed,{childList:true,subtree:true});
          enableFeedSwipe();
        }
      }
      activate(tabs.find(tab => '#' + tab.dataset.geTab === location.hash) || tabs[0]);galleries(home);
      if (location.hash === '#offer379') list.scrollIntoView({block:'start'});
      window.addEventListener('hashchange', () => {const tab=tabs.find(t => '#' + t.dataset.geTab === location.hash);if(tab)activate(tab);});
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',() => init(document));else init(document);
  document.addEventListener('shopify:section:load',event => init(event.target.parentElement));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["guttos-product-support"]) return;
  try {
    
(() => {
  const bar = document.getElementById('guttos-sticky');
  const button = document.getElementById('guttos-choose');
  const target = document.querySelector('.product__info-container variant-selects');
  const buy = document.querySelector('.product__info-container .product-form__submit');
  if (!bar || !button || !target || !buy) return;
  const observer = new IntersectionObserver(entries => {
    const visible = !entries[0].isIntersecting && window.scrollY > 180;
    bar.hidden = !visible;
    document.body.classList.toggle('gr-sticky-active', visible);
  }, { threshold: 0.1 });
  observer.observe(buy);
  button.addEventListener('click', () => {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const top = target.getBoundingClientRect().top + window.scrollY - 100;
    window.scrollTo({top, behavior: reduce ? 'auto' : 'smooth'});
    const input = target.querySelector('input:checked');
    if (input) input.focus({preventScroll:true});
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
